import React from "react";
import { useTranslation } from "react-i18next";
import { Logo, LanguageSwitch, ThemeToggle } from "@/components/Navbar";

// Shared two-column layout of the login / forgot / reset password pages.
export function AuthShell({ children }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="relative hidden lg:block overflow-hidden">
        <div className="absolute inset-0 qrise-gradient" />
        <div className="absolute inset-0 noise-bg" />
        <div className="relative z-10 p-10 h-full flex flex-col justify-between text-white">
          <Logo />
          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-bold opacity-80">QRISE</div>
            <h2 className="mt-3 text-5xl font-semibold tracking-tight leading-[1.05]">
              {t("auth.tagline_title")}
            </h2>
            <p className="mt-6 opacity-80 max-w-md leading-relaxed">{t("auth.tagline_body")}</p>
          </div>
          <div className="text-sm opacity-70">
            © {new Date().getFullYear()} QRISE — {t("auth.tagline_footer")}
          </div>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="flex items-center justify-between p-5 sm:p-8">
          <div className="lg:hidden">
            <Logo />
          </div>
          <div className="ml-auto flex items-center gap-1.5">
            <LanguageSwitch />
            <ThemeToggle />
          </div>
        </div>
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="w-full max-w-sm">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default AuthShell;
